export const trackingEvents = {
  aiFlowStarted: 'aiFlowStarted',
  aiFeedback: 'aiFeedback',
  aiFlowSelectQuestion: 'aiFlowSelectQuestion',
  aiFlowEnterQuestion: 'aiFlowEnterQuestion',
  aiFlowFollowupQuestion: 'aiFlowFollowupQuestion',
  aiFlowNewChat: 'aiFlowNewChat',
  aiExpanded: 'aiExpanded',
  aiFlowEnd: 'aiFlowEnd',
};
